// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   LUFGA FONT - EXCLUSIVE GLOBAL APPLICATION
   ============================================ */

/* 
  IMPORTANT: To use Lufga font, you need the actual font files.
  
  Download Lufga font files and place them in: src/styles/fonts/lufga/
  
  Required files:
  - Lufga-Light.woff2 (weight 300)
  - Lufga-Regular.woff2 (weight 400)
  - Lufga-Medium.woff2 (weight 500)
  - Lufga-SemiBold.woff2 (weight 600)
  - Lufga-Bold.woff2 (weight 700)
  - Lufga-ExtraBold.woff2 (weight 800)
  
  After adding the files, uncomment the @font-face rules below.
*/

/* @font-face declarations for Lufga font */
/* 
  IMPORTANT: These are commented out until you add the actual Lufga font files.
  After adding font files to src/styles/fonts/lufga/, uncomment these rules.
  
  Until then, the site will use the fallback sans-serif font.
*/

/*
@font-face {
  font-family: 'Lufga';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('./lufga/Lufga-Light.woff2') format('woff2'),
       url('./lufga/Lufga-Light.woff') format('woff');
}

@font-face {
  font-family: 'Lufga';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('./lufga/Lufga-Regular.woff2') format('woff2'),
       url('./lufga/Lufga-Regular.woff') format('woff');
}

@font-face {
  font-family: 'Lufga';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('./lufga/Lufga-Medium.woff2') format('woff2'),
       url('./lufga/Lufga-Medium.woff') format('woff');
}

@font-face {
  font-family: 'Lufga';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('./lufga/Lufga-SemiBold.woff2') format('woff2'),
       url('./lufga/Lufga-SemiBold.woff') format('woff');
}

@font-face {
  font-family: 'Lufga';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('./lufga/Lufga-Bold.woff2') format('woff2'),
       url('./lufga/Lufga-Bold.woff') format('woff');
}

@font-face {
  font-family: 'Lufga';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url('./lufga/Lufga-ExtraBold.woff2') format('woff2'),
       url('./lufga/Lufga-ExtraBold.woff') format('woff');
}
*/

/* ============================================
   GLOBAL CSS VARIABLES
   ============================================ */
:root {
  --font-family-base: 'Plus Jakarta Sans', 'Lufga', sans-serif;
  --bs-font-sans-serif: 'Plus Jakarta Sans', 'Lufga', sans-serif;
  --bs-body-font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif;
}

/* ============================================
   UNIVERSAL FONT APPLICATION
   ============================================ */

/* Apply to HTML and BODY */
html,
body {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Apply to ALL elements */
*,
*::before,
*::after {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* ============================================
   SPECIFIC ELEMENT OVERRIDES
   ============================================ */

/* All heading elements */
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* All text elements */
p, span, div, a, label, li, td, th {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* All form elements */
input,
input[type="text"],
input[type="email"],
input[type="password"],
input[type="number"],
input[type="tel"],
input[type="url"],
input[type="search"],
input[type="date"],
input[type="time"],
textarea,
select,
button {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* ============================================
   BOOTSTRAP COMPONENT OVERRIDES
   ============================================ */

.btn,
.form-control,
.form-select,
.form-check-label,
.input-group-text,
.nav-link,
.dropdown-item,
.dropdown-menu,
.modal-content,
.modal-header,
.modal-body,
.modal-footer,
.card,
.card-body,
.card-header,
.card-footer,
.card-title,
.table,
.badge,
.alert,
.breadcrumb,
.pagination,
.nav,
.navbar,
.navbar-brand {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* ============================================
   MDB REACT UI KIT OVERRIDES
   ============================================ */

.mdb-btn,
.mdb-input,
.mdb-select,
.mdb-tooltip,
.mdb-modal,
.mdb-card {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* ============================================
   REACT BOOTSTRAP TYPEAHEAD OVERRIDES
   ============================================ */

.rbt-input-multi,
.rbt-input-main,
.rbt-token,
.rbt-menu {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* ============================================
   UTILITY CLASS OVERRIDES
   ============================================ */

.text-sans-serif,
.text-monospace,
.font-weight-light,
.font-weight-normal,
.font-weight-bold {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* ============================================
   THIRD-PARTY LIBRARY OVERRIDES
   ============================================ */

/* Material-UI */
.MuiTypography-root,
.MuiButton-root,
.MuiInputBase-root {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* Ant Design */
.ant-btn,
.ant-input,
.ant-select,
.ant-table {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* React Select */
.react-select__control,
.react-select__menu,
.react-select__option {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* ============================================
   PREVENT OTHER FONTS
   ============================================ */

/* Disable system fonts */
[style*="font-family"] {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* Override any inline styles */
[class*="font"],
[class*="Font"],
[class*="text"] {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/fonts/lufga.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;;;;;;;;;;;;;;CAcC;;AAED,2CAA2C;AAC3C;;;;;CAKC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsDC;;AAED;;iDAEiD;AACjD;EACE,4DAA4D;EAC5D,8DAA8D;EAC9D,+DAA+D;AACjE;;AAEA;;iDAEiD;;AAEjD,2BAA2B;AAC3B;;EAEE,gEAAgE;EAChE,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;;;EAGE,gEAAgE;AAClE;;AAEA;;iDAEiD;;AAEjD,yBAAyB;AACzB;;EAEE,gEAAgE;AAClE;;AAEA,sBAAsB;AACtB;EACE,gEAAgE;AAClE;;AAEA,sBAAsB;AACtB;;;;;;;;;;;;;EAaE,gEAAgE;AAClE;;AAEA;;iDAEiD;;AAEjD;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE,gEAAgE;AAClE;;AAEA;;iDAEiD;;AAEjD;;;;;;EAME,gEAAgE;AAClE;;AAEA;;iDAEiD;;AAEjD;;;;EAIE,gEAAgE;AAClE;;AAEA;;iDAEiD;;AAEjD;;;;;EAKE,gEAAgE;AAClE;;AAEA;;iDAEiD;;AAEjD,gBAAgB;AAChB;;;EAGE,gEAAgE;AAClE;;AAEA,eAAe;AACf;;;;EAIE,gEAAgE;AAClE;;AAEA,iBAAiB;AACjB;;;EAGE,gEAAgE;AAClE;;AAEA;;iDAEiD;;AAEjD,yBAAyB;AACzB;EACE,gEAAgE;AAClE;;AAEA,+BAA+B;AAC/B;;;EAGE,gEAAgE;AAClE","sourcesContent":["/* ============================================\n   LUFGA FONT - EXCLUSIVE GLOBAL APPLICATION\n   ============================================ */\n\n/* \n  IMPORTANT: To use Lufga font, you need the actual font files.\n  \n  Download Lufga font files and place them in: src/styles/fonts/lufga/\n  \n  Required files:\n  - Lufga-Light.woff2 (weight 300)\n  - Lufga-Regular.woff2 (weight 400)\n  - Lufga-Medium.woff2 (weight 500)\n  - Lufga-SemiBold.woff2 (weight 600)\n  - Lufga-Bold.woff2 (weight 700)\n  - Lufga-ExtraBold.woff2 (weight 800)\n  \n  After adding the files, uncomment the @font-face rules below.\n*/\n\n/* @font-face declarations for Lufga font */\n/* \n  IMPORTANT: These are commented out until you add the actual Lufga font files.\n  After adding font files to src/styles/fonts/lufga/, uncomment these rules.\n  \n  Until then, the site will use the fallback sans-serif font.\n*/\n\n/*\n@font-face {\n  font-family: 'Lufga';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url('./lufga/Lufga-Light.woff2') format('woff2'),\n       url('./lufga/Lufga-Light.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Lufga';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('./lufga/Lufga-Regular.woff2') format('woff2'),\n       url('./lufga/Lufga-Regular.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Lufga';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url('./lufga/Lufga-Medium.woff2') format('woff2'),\n       url('./lufga/Lufga-Medium.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Lufga';\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url('./lufga/Lufga-SemiBold.woff2') format('woff2'),\n       url('./lufga/Lufga-SemiBold.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Lufga';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url('./lufga/Lufga-Bold.woff2') format('woff2'),\n       url('./lufga/Lufga-Bold.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Lufga';\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url('./lufga/Lufga-ExtraBold.woff2') format('woff2'),\n       url('./lufga/Lufga-ExtraBold.woff') format('woff');\n}\n*/\n\n/* ============================================\n   GLOBAL CSS VARIABLES\n   ============================================ */\n:root {\n  --font-family-base: 'Plus Jakarta Sans', 'Lufga', sans-serif;\n  --bs-font-sans-serif: 'Plus Jakarta Sans', 'Lufga', sans-serif;\n  --bs-body-font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif;\n}\n\n/* ============================================\n   UNIVERSAL FONT APPLICATION\n   ============================================ */\n\n/* Apply to HTML and BODY */\nhtml,\nbody {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n/* Apply to ALL elements */\n*,\n*::before,\n*::after {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* ============================================\n   SPECIFIC ELEMENT OVERRIDES\n   ============================================ */\n\n/* All heading elements */\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* All text elements */\np, span, div, a, label, li, td, th {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* All form elements */\ninput,\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ninput[type=\"tel\"],\ninput[type=\"url\"],\ninput[type=\"search\"],\ninput[type=\"date\"],\ninput[type=\"time\"],\ntextarea,\nselect,\nbutton {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* ============================================\n   BOOTSTRAP COMPONENT OVERRIDES\n   ============================================ */\n\n.btn,\n.form-control,\n.form-select,\n.form-check-label,\n.input-group-text,\n.nav-link,\n.dropdown-item,\n.dropdown-menu,\n.modal-content,\n.modal-header,\n.modal-body,\n.modal-footer,\n.card,\n.card-body,\n.card-header,\n.card-footer,\n.card-title,\n.table,\n.badge,\n.alert,\n.breadcrumb,\n.pagination,\n.nav,\n.navbar,\n.navbar-brand {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* ============================================\n   MDB REACT UI KIT OVERRIDES\n   ============================================ */\n\n.mdb-btn,\n.mdb-input,\n.mdb-select,\n.mdb-tooltip,\n.mdb-modal,\n.mdb-card {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* ============================================\n   REACT BOOTSTRAP TYPEAHEAD OVERRIDES\n   ============================================ */\n\n.rbt-input-multi,\n.rbt-input-main,\n.rbt-token,\n.rbt-menu {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* ============================================\n   UTILITY CLASS OVERRIDES\n   ============================================ */\n\n.text-sans-serif,\n.text-monospace,\n.font-weight-light,\n.font-weight-normal,\n.font-weight-bold {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* ============================================\n   THIRD-PARTY LIBRARY OVERRIDES\n   ============================================ */\n\n/* Material-UI */\n.MuiTypography-root,\n.MuiButton-root,\n.MuiInputBase-root {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* Ant Design */\n.ant-btn,\n.ant-input,\n.ant-select,\n.ant-table {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* React Select */\n.react-select__control,\n.react-select__menu,\n.react-select__option {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* ============================================\n   PREVENT OTHER FONTS\n   ============================================ */\n\n/* Disable system fonts */\n[style*=\"font-family\"] {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* Override any inline styles */\n[class*=\"font\"],\n[class*=\"Font\"],\n[class*=\"text\"] {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
